module.exports = __webpack_public_path__ + "img/linkedin.d3812f0d.svg";